import { FunctionComponent } from "react";
import { DashboardContextProvider, useDashboardContext, ViewMode } from "./dashboardContext";
import { Box } from "@mui/material";
import DashboardPageHeader from "./DashboardPageHeader";
import { DashboardProductAccordions, DashboardStoreAccordions } from "./DashboardFilters";
import DashboardGrid from "./DashboardGrid";

export const DashboardPage2: FunctionComponent = () => {
    const {
        currentView,
    } = useDashboardContext();

    return (
        <Box
            sx={{
                position: "fixed",
                height: "calc(100vh - 60px)",
                overflow: "hidden",
                width: "100%",
            }}
        >
            <DashboardPageHeader />
            <Box
                sx={{
                    display: 'flex',
                    height: "calc(100% - 122px)",
                    "&.k-grid-norecords": {
                        width: "100%",
                    },
                }}
            >
                {(currentView === ViewMode.PRODUCT) ? <DashboardProductAccordions /> : <DashboardStoreAccordions />}
                <DashboardGrid />
            </Box>
        </Box>
    )
};

export const DashboardPage2Wrapper: FunctionComponent = () => {
    return (
        <DashboardContextProvider>
            <DashboardPage2 />
        </DashboardContextProvider>
    );
}

export default DashboardPage2Wrapper;